import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field, FieldArray, formValueSelector, change } from 'redux-form';
import { length, numericality, required } from 'redux-form-validators';

import { TextField, SelectField } from 'redux-form-material-ui';

import { RaisedButton, MenuItem, IconButton } from 'material-ui';
import CreateIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import AddIcon from 'material-ui/svg-icons/content/add';

import { changePort } from 'actions/regions/ports';
import portActivities from 'data/portActivities';

import Emails from '../Port/ServiceProviders/Emails';
import Phones from '../Port/ServiceProviders/Phones';
import { formName } from '../../../data/formNames';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import _ from 'lodash';

const emptyLimitation = {
    maxDraught: undefined,
    maxBeam: undefined,
    maxLOA: undefined,
    maxDWT: undefined,
    channelDepth: undefined,
    berth: undefined,
};

const emptyServiceProvider = {
    activities: [],
    name: undefined,
    address: undefined,
    PIC: undefined,
    emails: [undefined],
    phones: [{
        phone: undefined,
        code: undefined,
    }],
    limitations: [emptyLimitation],
};

class ServiceProviders extends React.Component {
    constructor(props) {
        super(props);

        this.removeServiceProvider = this.removeServiceProvider.bind(this);
        this.addServiceProvider = this.addServiceProvider.bind(this);
    }

    removeServiceProvider(index) {
        const { fields } = this.props;
        fields.remove(index);
    }

    addServiceProvider() {
        const { fields } = this.props;

        fields.push(emptyServiceProvider);
    }

    addPortLimitation = (providerIndex) => {
        const serviceProvidersCopy = _.cloneDeep(this.props.serviceProviders);
        
        serviceProvidersCopy[providerIndex].limitations.push(emptyLimitation);
        
        this.props.changePort({ 
            serviceProviders: serviceProvidersCopy,
        });
    }

    removePortLimitation = (providerIndex, limitationIndex) => {
        const serviceProvidersCopy = _.cloneDeep(this.props.serviceProviders);
        
        serviceProvidersCopy[providerIndex].limitations = serviceProvidersCopy[providerIndex].limitations.splice(limitationIndex, 1);
        
        this.props.changePort({ 
            serviceProviders: serviceProvidersCopy,
        });
    }

    render() {
        const { fields, serviceProviders, styles } = this.props;
    
        return (
            <Fragment>
                {
                    fields.map((field, index) => (<div key={`serviceProvider_${index}`}>
                        <div className="paper-block">
                            <RaisedButton
                                label="Remove Service Provider"
                                labelStyle={styles.btn.labelStyle}
                                style={styles.btn.style}
                                labelPosition="before"
                                icon={<DeleteIcon />}
                                secondary
                                onClick={() => {
                                    this.removeServiceProvider(index);
                                }}
                            />

                            <div className="row">
                                <div className="col-xs-6">
                                    <Field
                                        component={SelectField}
                                        name={`${field}.activities`}
                                        multiple
                                        floatingLabelText='Activities'
                                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                                        fullWidth
                                        autoWidth
                                        value={serviceProviders[index].activities}
                                        validate={required()}
                                    >
                                        {
                                            portActivities.map((portActivity, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={portActivity}
                                                    primaryText={portActivity}
                                                />
                                            ))
                                        }
                                    </Field>
                                </div>
                                <div className="col-xs-6">
                                    <Field
                                        component={TextField}
                                        name={`${field}.name`}
                                        floatingLabelText='Company name'
                                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                                        fullWidth
                                        validate={[required(), length({ min: 3, max: 266 })]}
                                    />
                                </div>
                            </div>
                            {
                                serviceProviders[index].activities && serviceProviders[index].activities.includes('Stevedoring Company') &&
                                <FieldArray
                                    name={`${field}.limitations`}
                                    component={renderLimitations}
                                    styles={styles}
                                />                                
                            }
                                    
                            <div className="row">
                                <div className="col-xs-6">
                                    <FieldArray
                                        name={`${field}.emails`}
                                        component={Emails}
                                    />
                                </div>
                                <div className="col-xs-6">
                                    <FieldArray
                                        name={`${field}.phones`}
                                        component={Phones}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-6">
                                    <Field
                                        component={TextField}
                                        name={`${field}.address`}
                                        floatingLabelText='Address'
                                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                                        fullWidth
                                        validate={required()}
                                    />
                                </div>
                                <div className="col-xs-6">
                                    <Field
                                        component={TextField}
                                        name={`${field}.PIC`}
                                        floatingLabelText='PIC'
                                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                                        fullWidth
                                        validate={required()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    ))
                }

                <RaisedButton
                    label="Add Service Provider"
                    labelStyle={styles.btn.labelStyle}
                    style={styles.btn.addServiceProvider.style}
                    labelPosition="before"
                    icon={<AddIcon />}
                    primary
                    onClick={this.addServiceProvider}
                />
            </Fragment>
        );
    }
}

function renderLimitations({ fields, styles }) {
    return (
        <div>
            {
                fields.map((field, limitationIndex) => (
                    <div 
                        className="row"
                    >
                        <div className="col-xs-12">
                            <Field
                                component={TextField}
                                name={`${field}.berth`}
                                floatingLabelText='Berth'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                style={{ width: '14%' }}
                            />
                            <Field
                                component={TextField}
                                name={`${field}.maxDraught`}
                                floatingLabelText='Max draft, m:'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                style={{ width: '14%' }}
                                validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            />
                            <Field
                                component={TextField}
                                name={`${field}.maxBeam`}
                                floatingLabelText='Max beam, m:'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                style={{ width: '14%', marginLeft: '10px' }}
                                validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            />
                            <Field
                                component={TextField}
                                name={`${field}.maxLOA`}
                                floatingLabelText='Max LOA, m:'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                style={{ width: '14%', marginLeft: '10px' }}
                                validate={[numericality({ '>=': 0, '<=': 1000, allowBlank: true })]}
                            />
                            <Field
                                component={TextField}
                                name={`${field}.maxDWT`}
                                floatingLabelText='Max DWT, m:'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                style={{ width: '14%', marginLeft: '10px' }}
                                validate={[numericality({ '>=': 0, '<=': 1000000, allowBlank: true })]}
                            />
                            <Field
                                component={TextField}
                                name={`${field}.channelDepth`}
                                floatingLabelText='Channel Depth, m:'
                                floatingLabelStyle={styles.textField.floatingLabelStyle}
                                style={{ width: '14%', marginLeft: '10px' }}
                                validate={[numericality({ '>=': 0, '<=': 100, allowBlank: true })]}
                            />
                            <div className='center-xs' style={{ display: 'inline-flex', width: '11%' }}>
                                {
                                    limitationIndex === 0 ?
                                        <IconButton
                                            iconStyle={styles.icon}
                                            onClick={() => fields.push(emptyLimitation)}
                                        >
                                            <ControlPointIcon />
                                        </IconButton>
                                        :
                                        <IconButton
                                            iconStyle={styles.icon}
                                            onClick={() => fields.remove(limitationIndex)}
                                        >
                                            <ContentRemoveIcon />
                                        </IconButton>
                                }
                            </div>
                        </div>
                    </div>
                ))
            }
        
        </div>
    );
}

ServiceProviders.propTypes = {

};

ServiceProviders.defaultProps = {

};

const selector = formValueSelector(formName.portCreate);
export default connect(
    (state, ownProps) => ({
        ...ownProps,
        serviceProviders: selector(state, 'serviceProviders'),
    }),
    dispatch => bindActionCreators({
        changePort,
        change,
    }, dispatch),
)(ServiceProviders);



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/ServiceProviders.jsx